module.exports = __webpack_public_path__ + "static/img/Íconos_atrás.c026195b.svg";